var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveAs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0C13.1406 0 13.2708 0.0260417 13.3906 0.078125C13.5104 0.130208 13.6146 0.203125 13.7031 0.296875C13.7969 0.385417 13.8698 0.489583 13.9219 0.609375C13.974 0.729167 14 0.859375 14 1V14H1.78906L0 12.2031V1C0 0.859375 0.0260417 0.729167 0.078125 0.609375C0.130208 0.489583 0.200521 0.385417 0.289062 0.296875C0.382812 0.203125 0.489583 0.130208 0.609375 0.078125C0.729167 0.0260417 0.859375 0 1 0H13ZM3 6H11V1H3V6ZM9 10H4V13H5V11H6V13H9V10ZM13 1H12V7H2V1H1V11.7891L2.20312 13H3V9H10V13H13V1Z",
    fill: "#205493"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveAs);
export default __webpack_public_path__ + "static/media/saveAs.685bd482a52e23e2c999660c6e52788f.svg";
export { ForwardRef as ReactComponent };